import React, { useState, useReducer } from 'react'
import { Col, Divider, Row, Space } from 'antd'
import _, { get } from 'lodash'
import styled from 'styled-components'
import { SectionStyle } from '../index.styled'
import EditableText from '../components/EditableText'
import { CircleEditButton } from '../components/Widgets'
import { LifestyleGoalIcon } from '../../../asserts/svgWrappers/assessmentReview'
import { FlexBox } from '../../../components/UI/FlexBox'
import { VictoryPie } from 'victory'
import classNames from 'classnames'
import TriangleGraph from '../../../components/questionnaire/comp/triangleGraph'
import { RangeColors } from '../../../utils'
import { compactMap } from '../../../utils/array+extensions'
import HideWrap from '../../../components/assessmentReview/comp/hideWrap'
import ConditionalHideWrap from '../../../components/assessmentReview/comp/ConditionalHidewrap'

const Container = styled.section`
  ${SectionStyle}

  .note {
    flex-grow: 1;
  }
`

const NOTES_FIELDS = {
  LIFESTYLE_HEADER_NOTE: 'lifestyle_header_note',
  LIFESTYLE_DETAIL_NOTE: 'lifestyle_detail_note',
  LIFESTYLE_GOALS_NOTE: 'lifestyle_goals_note',
  LIFESTYLE_CTE_NOTE: 'lifestyle_cte_note'
}

export default function LifestyleSection(props) {
  const { data, notes, handleCommendSave, editabled, view, hideSection, hideSectionHandle} = props
  const [headerTextEditing, setHeaderTextEditing] = useState(false)

  const [detailTextEditing, setDetailTextEditing] = useState(false)

  const score = _.get(data, 'lifestyleScore', {})
  const headerNote = notes.find(
    (n) => n.pillar === NOTES_FIELDS.LIFESTYLE_HEADER_NOTE
  )

  const detailNote = notes.find(
    (n) => n.pillar === NOTES_FIELDS.LIFESTYLE_DETAIL_NOTE
  )

  const commonProps = {
    ...score,
    ...{ handleCommendSave, notes, editabled }
  }

  return (

    <Container>
      <ConditionalHideWrap
        name="Lifestyle Summary"
        title="Lifestyle Summary"
        syncStatus={hideSectionHandle}
        status={hideSection}
        view={view}
        condition={
          view === 'Draft' || (view !== 'Draft' && !hideSection.includes('Lifestyle Summary'))
        }
      >
      <h1 className="ar-section-title">Lifestyle Summary</h1>
      <FlexBox>
        <EditableText
          className={'note'}
          value={(headerNote && headerNote.memo) || ''}
          placeholder={editabled ? 'Please type here.' : '-'}
          editing={headerTextEditing}
          setEditing={setHeaderTextEditing}
          onSave={(text) => {
            handleCommendSave(text, NOTES_FIELDS.LIFESTYLE_HEADER_NOTE)
          }}
        />
        {!headerTextEditing && editabled && (
          <CircleEditButton
            style={{
              marginLeft: '17px'
            }}
            onClick={() => {
              setHeaderTextEditing(true)
            }}
          />
        )}
      </FlexBox>

      <h2
        className="ar-section-group-title"
        style={{
          marginTop: 36,
          marginBottom: 12
        }}
      >
        Detail
      </h2>
      <FlexBox>
        <EditableText
          className={'note'}
          value={(detailNote && detailNote.memo) || ''}
          placeholder={editabled ? 'Please type here.' : '-'}
          editing={detailTextEditing}
          setEditing={setDetailTextEditing}
          onSave={(text) => {
            handleCommendSave(text, NOTES_FIELDS.LIFESTYLE_DETAIL_NOTE)
          }}
        />
        {!detailTextEditing && editabled && (
          <CircleEditButton
            style={{
              marginLeft: '17px'
            }}
            onClick={() => {
              setDetailTextEditing(true)
            }}
          />
        )}
      </FlexBox>
      </ConditionalHideWrap>
      <Goals data={_.get(data, 'goals', {})} {...commonProps} />
      <Score {...commonProps} view={view} hideSection={hideSection} hideSectionHandle={hideSectionHandle} />
      <Divider />
      <ScoreBreakdown {...commonProps} />
      <QQTNotes {...commonProps} view={view} hideSection={hideSection} hideSectionHandle={hideSectionHandle}/>

      <Summary {...commonProps} />
    </Container>
  )
}

const GoalsContainer = styled.div`
  background-color: rgba(250, 250, 250, 1);
  padding: 40px;
  border: 1px solid rgba(227, 230, 234, 1);
  margin-top: 64px;
  margin-bottom: 20px;

  .main-title {
    color: #264382;
    font-size: 24px;
    letter-spacing: 0.3px;
    margin-left: 16px;
  }

  .goals-note {
    margin-top: 24px;
    margin-bottom: 48px;
    color: #70808e;
  }

  .goal-order-title {
    display: inline-block;
    text-align: center;
    width: 40px;
    height: 40px;
    border-radius: 20px;
    border: 1px solid rgba(43, 75, 142, 1);
    line-height: 40px;
    color: rgba(38, 67, 130, 1);
    background-color: rgba(235, 237, 245, 1);
  }

  .dash-line {
    border-bottom: 1px dashed rgba(0, 0, 0, 0.2);
    flex-grow: 1;
    margin: 0 20px;
  }

  .goal-name {
    margin-top: 16px;
    color: rgba(76, 96, 114, 1);
    line-height: 35.76px;
    font-size: 24px;
    letter-spacing: 0.3px;
    margin-right: 10px;
  }
`

const Goals = (props) => {
  const { data, notes, handleCommendSave, editabled } = props
  const [goalsNoteEditing, setGoalsNoteEditing] = useState(false)
  const note = notes.find((n) => n.pillar === NOTES_FIELDS.LIFESTYLE_GOALS_NOTE)
  return (
    <GoalsContainer>
      <FlexBox justifyContent="space-between" alignItems="center">
        <FlexBox alignItems="center">
          <LifestyleGoalIcon />
          <span className="main-title">Goals</span>
        </FlexBox>
        {!goalsNoteEditing && editabled && (
          <CircleEditButton
            onClick={() => {
              setGoalsNoteEditing(true)
            }}
          />
        )}
      </FlexBox>
      <EditableText
        className={['note', 'goals-note']}
        value={(note && note.memo) || ''}
        placeholder={editabled ? 'Please type here.' : '-'}
        editing={goalsNoteEditing}
        setEditing={setGoalsNoteEditing}
        onSave={(text) => {
          handleCommendSave(text, NOTES_FIELDS.LIFESTYLE_GOALS_NOTE)
        }}
      />
      <Row>
        <Col span={9}>
          <div>
            <FlexBox alignItems="center">
              <span className="goal-order-title">1</span>
              <div className="dash-line" />
            </FlexBox>
            <div className="goal-name">{_.get(data, 'primary_goal', '-')}</div>
          </div>
        </Col>
        <Col span={9}>
          <div>
            <FlexBox alignItems="center">
              <span className="goal-order-title">2</span>
              <div className="dash-line" />
            </FlexBox>
            <div className="goal-name">
              {_.get(data, 'secondary_goal', '-')}
            </div>
          </div>
        </Col>
        <Col span={6}>
          <div>
            <span className="goal-order-title">3</span>
            <div className="goal-name">
              {_.get(data, 'tertiary_goal') || 'No Goal'}
            </div>
          </div>
        </Col>
      </Row>
    </GoalsContainer>
  )
}

const ScoreContainer = styled.div`
  margin-top: 64px;
  .lifestyle-score-group {
    margin-top: 48px;
    display: flex;
    justify-content: center;
    .chart-container {
      width: 57%;
    }
  }
`

const Score = (props) => {
  return (
    <ConditionalHideWrap
      name="Lifestyle Score"
      title="Lifestyle Score"
      syncStatus={props.hideSectionHandle}
      status={props.hideSection}
      view={props.view}
      condition={
        props.view === 'Draft' || (props.view !== 'Draft' && !props.hideSection.includes('Lifestyle Score'))
      }
    >
    <ScoreContainer>
      <h2 className="ar-section-group-title">Lifestyle Score</h2>
      <div className="lifestyle-score-group">
        <div className="chart-container">
          {/* <TriangleChart /> */}
          <TriangleGraph
            exercise={_.get(props, 'exercise.score.total', '0')}
            nutrition={_.get(props, 'nutrition.score.total', '0')}
            sleep={_.get(props, 'sleep.score.total', '0')}
          />
        </div>
      </div>
    </ScoreContainer>
    </ConditionalHideWrap>
  )
}

const ScoreBreakdownContainer = styled.div`
  .qqt-card {
    border: 1px solid rgba(227, 230, 234, 1);
    background-color: rgba(250, 250, 250, 1);
    padding: 20px 40px 40px;
    .pillar-status {
      width: 130px;
      .pillar-name-label {
        font-size: 20px;
        margin-bottom: 8px;
        margin-top: -12px;
        color: rgba(50, 63, 74, 1);
      }
      .pillar-status-label {
        font-size: 15px;
        padding: 5px 13px;
        color: white;
        border-radius: 6px;
        background-color: lightgray;
        &.fair {
          background-color: rgba(245, 186, 64, 1);
        }
        &.optimal {
          background-color: rgba(64, 196, 124, 1);
        }
        &.poor {
          background-color: rgba(255, 107, 0, 1);
        }
      }
    }
    .pie {
      width: 130px;
      position: relative;
      .pillar-score-label {
        color: rgba(50, 63, 74, 1);
        font-size: 24px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .ant-divider-horizontal {
      margin-top: 0px;
    }
    .qqt-title-label {
      color: rgba(76, 96, 114, 1);
      font-size: 15px;
    }
    .qqt-status-label {
      font-size: 15px;
      font-weight: 600;

      &.fair {
        color: rgba(245, 186, 64, 1);
      }
      &.optimal {
        color: rgba(64, 196, 124, 1);
      }
      &.poor {
        color: rgba(255, 107, 0, 1);
      }
    }
  }
`

const ScoreBreakdown = (props) => {
  const level = {
    1: 'poor',
    2: 'fair',
    3: 'optimal'
  }

  const pillars = ['exercise', 'nutrition', 'sleep']

  return (
    <ScoreBreakdownContainer>
      <h2 className="ar-section-group-title">Score Breakdown</h2>
      <Row gutter={24} style={{ marginTop: 36 }}>
        {pillars.map((pillar, index) => {
          const pillarScore = get(props, `${pillar}.score.total`)
          const pillarLevel = get(props, `${pillar}.level.total`)
          const quantity = get(props, `${pillar}.level.quantity`)
          const quality = get(props, `${pillar}.level.quality`)
          const timing = get(props, `${pillar}.level.timing`)
          return (
            <Col span={8} key={index}>
              <div className="qqt-card">
                <FlexBox justifyContent="space-between" alignItems="center">
                  <div className="pillar-status">
                    <div className="pillar-name-label">
                      {_.capitalize(pillar)}
                    </div>
                    <span
                      className={classNames(
                        'pillar-status-label',
                        pillarLevel && level[pillarLevel]
                      )}
                    >
                      {pillarLevel ? _.capitalize(level[pillarLevel]) : '-'}
                    </span>
                  </div>
                  <div className="pie">
                    <VictoryPie
                      innerRadius={110}
                      data={[quantity, quality, timing].map((l) => {
                        switch (l) {
                          case 1:
                            return { x: 'AT RISK', y: 1, color: '#FF6B00' }
                          case 2:
                            return { x: 'CONCERN', y: 1, color: '#F5BA40' }
                          case 3:
                            return { x: 'OPTIMAL', y: 1, color: '#40C47C' }
                          default:
                            return { x: 'N/A', y: 1, color: 'lightgray' }
                        }
                      })}
                      style={{
                        labels: { fill: 'transparent' },
                        data: {
                          fill: (datum) => datum.color
                        }
                      }}
                    />
                    <div className={classNames('pillar-score-label')}>
                      {pillarScore || '--'}
                    </div>
                  </div>
                </FlexBox>
                <Divider />
                <Space direction="vertical" size={12} style={{ width: '100%' }}>
                  <FlexBox justifyContent="space-between">
                    <span className="qqt-title-label">Quantity</span>
                    <span
                      className={classNames(
                        'qqt-status-label',
                        (quantity && level[quantity]) || ''
                      )}
                    >
                      {_.capitalize(quantity && level[quantity]) || '-'}
                    </span>
                  </FlexBox>
                  <FlexBox justifyContent="space-between">
                    <span className="qqt-title-label">Quality</span>
                    <span
                      className={classNames(
                        'qqt-status-label',
                        (quality && level[quality]) || ''
                      )}
                    >
                      {_.capitalize(quality && level[quality]) || '-'}
                    </span>
                  </FlexBox>
                  <FlexBox justifyContent="space-between">
                    <span className="qqt-title-label">Timing</span>
                    <span
                      className={classNames(
                        'qqt-status-label',
                        (timing && level[timing]) || ''
                      )}
                    >
                      {_.capitalize(timing && level[timing]) || '-'}
                    </span>
                  </FlexBox>
                </Space>
              </div>
            </Col>
          )
        })}
      </Row>
    </ScoreBreakdownContainer>
  )
}

const QQTNotesContainer = styled.div`
  border: 1px solid #e6e9f2;
  margin-top: 36px;
  background-color: rgba(250, 250, 250, 1);
  display: flex;
  .notes-half-container {
    padding: 16px 36px;
    color: rgba(50, 63, 74, 1);
    width: 50%;
    &:first-child {
      border-right: 1px solid rgba(230, 233, 242, 1);
    }
    .notes-title {
      padding: 24px 0;
      font-size: 24px;
      line-height: 1.5;
      letter-spacing: 0.3px;

      border-bottom: 1px solid rgba(230, 233, 242, 1);
    }

    .single-note-container {
      padding: 36px 0;

      .note-pillar-title {
        font-size: 20px;
        line-height: 1.5;
        margin-bottom: 16px;
      }
    }
  }
`

const QQTNotes = (props) => {
  const { editabled, handleCommendSave, notes, view, hideSection, hideSectionHandle } = props
  const keyWinNotes = [
    'lifestyle_key_wins_1_note',
    'lifestyle_key_wins_2_note',
    'lifestyle_key_wins_3_note'
  ]
  const keyImprovementNotes = [
    'lifestyle_key_improvement_1_note',
    'lifestyle_key_improvement_2_note',
    'lifestyle_key_improvement_3_note'
  ]
  const [noteEditState, dispatch] = useReducer(noteEditReducer, {
    lifestyle_key_wins_1_note: false,
    lifestyle_key_wins_2_note: false,
    lifestyle_key_wins_3_note: false,
    lifestyle_key_improvement_1_note: false,
    lifestyle_key_improvement_2_note: false,
    lifestyle_key_improvement_3_note: false
  })

  return (
    <QQTNotesContainer>
      <div className="notes-half-container">
        <ConditionalHideWrap
          name="Key Wins"
          title="Key Wins -lifestyle"
          syncStatus={hideSectionHandle}
          status={hideSection}
          view={view}
          isKeyWins={true}
          condition={
            view === 'Draft' || (view !== 'Draft' && !hideSection.includes('Key Wins'))
          }
        >
        <div className="notes-title">Key Wins:</div>
        {compactMap(keyWinNotes, (noteKey) => {
          return notes.find((n) => n.pillar === noteKey)
        }).map((note, index) => (
          <div className="single-note-container" key={index}>
            <FlexBox justifyContent="space-between">
              <span className="note-pillar-title">{note.title}</span>
              {!noteEditState[note.pillar] && editabled && (
                <CircleEditButton
                  onClick={() => {
                    dispatch({ type: 'edit', noteKey: note.pillar })
                  }}
                />
              )}
            </FlexBox>
            <EditableText
              className={['note', 'goals-note']}
              value={(note && note.memo) || ''}
              placeholder={editabled ? 'Please type here.' : '-'}
              editing={noteEditState[note.pillar]}
              setEditing={() => {
                dispatch({ type: 'save', noteKey: note.pillar })
              }}
              onSave={(text) => {
                handleCommendSave(text, note.pillar)
              }}
            />
          </div>
        ))}
        </ConditionalHideWrap>
      </div>
      <div className="notes-half-container">
        <ConditionalHideWrap
          name="Area of Improvement:"
          title="Area of Improvement: Lifetsyle"
          syncStatus={hideSectionHandle}
          status={hideSection}
          view={view}
          isKeyWins={true}
          condition={
            view === 'Draft' || (view !== 'Draft' && !hideSection.includes('Area of Improvement:'))
          }
        >
        <div className="notes-title">Area of Improvement:</div>
        {compactMap(keyImprovementNotes, (noteKey) => {
          return notes.find((n) => n.pillar === noteKey)
        }).map((note, index) => (
          <div className="single-note-container" key={index}>
            <FlexBox justifyContent="space-between">
              <span className="note-pillar-title">{note.title}</span>
              {!noteEditState[note.pillar] && editabled && (
                <CircleEditButton
                  onClick={() => {
                    dispatch({ type: 'edit', noteKey: note.pillar })
                  }}
                />
              )}
            </FlexBox>
            <EditableText
              className={['note', 'goals-note']}
              value={(note && note.memo) || ''}
              placeholder={editabled ? 'Please type here.' : '-'}
              editing={noteEditState[note.pillar]}
              setEditing={() => {
                dispatch({ type: 'save', noteKey: note.pillar })
              }}
              onSave={(text) => {
                handleCommendSave(text, note.pillar)
              }}
            />
          </div>
        ))}
        </ConditionalHideWrap>
      </div>
    </QQTNotesContainer>
  )

  function noteEditReducer(state, action) {
    switch (action.type) {
      case 'edit':
        return {
          ...state,
          [action.noteKey]: true
        }
      case 'save':
        return {
          ...state,
          [action.noteKey]: false
        }
      default:
        return { ...state }
    }
  }
}

const SummaryContainer = styled.div`
  background-color: rgba(250, 250, 250, 1);
  border: 1px solid rgba(230, 233, 242, 1);
  padding: 36px;
  display: flex;
  align-items: center;
  margin-top: 64px;
  margin-bottom: 77px;
  .score {
    width: 120px;
    height: 120px;
    border-radius: 60px;
    color: ${(props) => props.color};
    background-color: ${(props) => props.backgroundColor};
    flex-shrink: 0;
    margin-right: 54px;
    font-size: 36px;
    letter-spacing: 0.77px;
  }
  .summary-title {
    color: rgba(76, 96, 114, 1);
    font-size: 24px;
    letter-spacing: 0.3px;
    line-height: 1.5;
    margin-bottom: 10px;
  }
`

const Summary = (props) => {
  const { notes, handleCommendSave, editabled } = props
  const [noteEditing, setNoteEditing] = useState(false)
  const note = notes.find((n) => n.pillar === NOTES_FIELDS.LIFESTYLE_CTE_NOTE)
  const cte = get(props, 'cte')
  return (
    <SummaryContainer {...getCTEColor(cte)}>
      <FlexBox justifyContent="center" alignItems="center" className="score">
        {cte || '-'}
      </FlexBox>
      <div
        style={{
          position: 'relative',
          flexGrow: 1
        }}
      >
        <div className="summary-title">Capacity to Exercise</div>
        <FlexBox justifyContent="space-between">
          <EditableText
            className={'note'}
            value={(note && note.memo) || ''}
            placeholder={'Please type here.'}
            editing={noteEditing}
            setEditing={setNoteEditing}
            onSave={(text) => {
              handleCommendSave(text, NOTES_FIELDS.LIFESTYLE_CTE_NOTE)
            }}
          />
          {!noteEditing && editabled && (
            <CircleEditButton
              onClick={() => {
                setNoteEditing(true)
              }}
            />
          )}
        </FlexBox>
      </div>
    </SummaryContainer>
  )

  function getCTEColor(score) {
    if (score >= 80) {
      return {
        color: RangeColors.blue,
        backgroundColor: 'rgba(134, 192, 216, 0.1)'
      }
    } else if (score >= 60) {
      return {
        color: RangeColors.emerald,
        backgroundColor: 'rgba(134, 216, 171, 0.1)'
      }
    } else if (score >= 40) {
      return {
        color: RangeColors.yellow,
        backgroundColor: 'rgba(253, 181, 28, 0.1)'
      }
    } else if (score >= 20) {
      return {
        color: RangeColors.orange,
        backgroundColor: 'rgba(255, 207, 186, 0.1)'
      }
    } else {
      return {
        color: RangeColors.red,
        backgroundColor: 'rgba(255, 207, 186, 0.1)'
      }
    }
  }
}
